import * as React from 'react'

export default class SPDDailyRunsheetSchedule extends React.Component {

  viewHistory = (e) => {
    e.preventDefault()
    if (this.props.updateActivePage) {
      this.props.updateActivePage('history', this.props.schedule, 'runsheet/daily')
    }

  }

  render() {

    const schedule = this.props.schedule

    let crew = []
    if (schedule.jobcard.simPROScheduleCrew) {
      schedule.jobcard.simPROScheduleCrew.forEach((member, i) => {
        crew.push(<div key={'crew-' + schedule.id + '-crew-' + i}>{member}</div>)
      })
    }

    return (
      <article className="schedule">
        <div className="container address" onClick={this.viewHistory}>
          <div className="addressBox">
            <h2>{schedule.job.site.address} {schedule.job.site.suburb} {schedule.job.siteName}</h2>
            {
              schedule.jobcard.simPROJobID && schedule.job.site.name ?
                (<h2>Job {schedule.jobcard.simPROJobID} {<span>&#8282;</span>} {schedule.job.site.name}</h2>) :
                schedule.jobcard.simPROJobID ?
                  (<h2>Job {schedule.jobcard.simPROJobID}</h2>) :
                  schedule.job.site.name ?
                    (<h2>{schedule.job.site.name}</h2>) :
                    <h2>`No Site`</h2>
            }
          </div>
          <button className="button small"><i className="fas fa-info-circle"></i> Job Info</button>
        </div>

        <div className="container detail">
          {
            schedule.costCentreName && schedule.costCentreName !== '' ? (
              <div className="notesTitle">{schedule.costCentreName}</div>
            ) : null
          }

          <div className="row">
            <i className="far fa-file fa-fw"></i>
            <div className="notes" dangerouslySetInnerHTML={{
              __html:
                schedule.jobcard.notes ? schedule.jobcard.notes : `(No Notes)`
            }}></div>
          </div>

          {
            crew.length > 0 ? (
              <div className="row">
                <i className="fas fa-user fa-fw"></i>
                <div className="crew">
                  {
                    crew
                  }
                </div>
              </div>
            ) : null
          }
        </div>

      </article>
    )


  }

}
